"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiLinkOverrides = function (theme) { return ({
    root: {
        "&$focusVisible": {
            outline: "none",
            background: theme.palette.action.hover,
        },
    },
    button: {
        "&:disabled": {
            opacity: 0.3,
            cursor: "default",
        },
    },
}); };
//# sourceMappingURL=MuiLink.js.map